import { CONFIG_PERMISSIONS } from '../../src/constants/ConfigPermission';
import Banner from '../assets/images/common/web-banner.jpg';
import BannerMob from '../assets/images/common/mob-banner.jpg';

const WHITE_LABEL_BANNERS = {
  sky11: [
    {
      publicUrl: 'https://sky-asserts.s3.eu-west-2.amazonaws.com/banner1-web.png',
      text: 'WORLD_CUP',
      url: '/',
      configPermission: CONFIG_PERMISSIONS.cricket,
    },
    {
      publicUrl: 'https://sky-asserts.s3.eu-west-2.amazonaws.com/banner2-web.png',
      text: 'WORLD_CUP',
      url: '/',
      configPermission: CONFIG_PERMISSIONS.cricket,
    },
    {
      publicUrl: 'https://sky-asserts.s3.eu-west-2.amazonaws.com/banner3-web.jfif',
      text: 'WORLD_CUP',
      url: '/',
      configPermission: CONFIG_PERMISSIONS.cricket,
    },
    {
      publicUrl: Banner,
      text: 'WORLD_CUP',
      url: '/',
      configPermission: CONFIG_PERMISSIONS.cricket,
    },
  ],
  bigb11: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/Bigb11/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  cbtfsky11: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/CbtfSky11/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  dubsky11: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/DubSky11/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  fair11: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/Fair11/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  indian11: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/Indian11/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  playbetexch: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/PlayBetExch/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  maxexch11: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/MaxExch11/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  playbhai: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/PlayBhai/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  playexch247: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/PlayExch247/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  playsky11: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/PlaySky11/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  sky11bet: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/Sky11Bet/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  skythunders: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/SkyThunders/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  skyx11: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/Skyx11/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  starcoinexchange: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/StarCoinExchange/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  titosexch: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/TitosExch/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  banner: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/TitosExch/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
};
const WHITE_LABEL_BANNERS_MOBILE = {
  sky11: [
    {
      publicUrl: 'https://sky-asserts.s3.eu-west-2.amazonaws.com/banner1-mob.png',
      text: 'WORLD_CUP',
      url: '/',
      configPermission: CONFIG_PERMISSIONS.cricket,
    },
    {
      publicUrl: 'https://sky-asserts.s3.eu-west-2.amazonaws.com/banner2-mob.png',
      text: 'WORLD_CUP',
      url: '/',
      configPermission: CONFIG_PERMISSIONS.cricket,
    },
    {
      publicUrl: 'https://sky-asserts.s3.eu-west-2.amazonaws.com/banner3-mob.jfif',
      text: 'WORLD_CUP',
      url: '/',
      configPermission: CONFIG_PERMISSIONS.cricket,
    },

    {
      publicUrl: BannerMob,
      text: 'WORLD_CUP',
      url: '/',
      configPermission: CONFIG_PERMISSIONS.cricket,
    },
  ],
  bigb11: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/Bigb11/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  cbtfsky11: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/CbtfSky11/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  dubsky11: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/DubSky11/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  fair11: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/Fair11/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  indian11: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/Indian11/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  playbetexch: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/PlayBetExch/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  maxexch11: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/MaxExch11/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  playbhai: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/PlayBhai/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  playexch247: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/PlayExch247/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  playsky11: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/PlaySky11/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  sky11bet: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/Sky11Bet/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  skythunders: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/SkyThunders/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  skyx11: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/Skyx11/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  starcoinexchange: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/StarCoinExchange/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  titosexch: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/TitosExch/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  uniexch: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/TitosExch/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
  banner: [
    {
      publicUrl:
        'https://sky-asserts.s3.eu-west-2.amazonaws.com/whitelabel/TitosExch/wl_banner1.png',
      text: 'WORLD_CUP 2021',
      url: `/exchange_sports/cricket`,
      configPermission: CONFIG_PERMISSIONS.sports,
    },
  ],
};

export function getWebBanners(brand: string) {
  return WHITE_LABEL_BANNERS[brand.toLowerCase()]
    ? WHITE_LABEL_BANNERS[brand.toLowerCase()]
    : WHITE_LABEL_BANNERS['banner'];
}

export function getMobBanners(brand: string) {
  return WHITE_LABEL_BANNERS_MOBILE[brand.toLowerCase()]
    ? WHITE_LABEL_BANNERS_MOBILE[brand.toLowerCase()]
    : WHITE_LABEL_BANNERS_MOBILE['banner'];
}

export default {
  WHITE_LABEL_BANNERS,
  WHITE_LABEL_BANNERS_MOBILE,
};
